/* eslint-disable no-irregular-whitespace */
import React from 'react'
import { withPrefix } from 'gatsby'
import * as Styles from './takara_p_c.module.scss'
import { Contact } from '@/components/general/contact-takara_p_c'
import { Layout } from '@/components/general/layout'
import { Seo } from '@/components/general/seo'

const Takara_p_cPage = ({ location }) => (
  <Layout location={location}>
    <Seo title="これまで煩雑だった決算開示業務における課題を両社のナレッジを融合し解決に導く" />
    <section>
      <div className={Styles.takara_p_c__head}>
        <div className={Styles.takara_p_c__head__bg} />
        
        <div className={Styles.takara_p_c__head__logowrap}>
          <img
              src={withPrefix('/page-title_icon_logo.svg')}
              alt=""
              className={Styles.takara_p_c__head__logowrap__logo}
              width={751.43}
              height={737.03}
            />
        </div>
      </div>
      <div className={Styles.takara_p_c__body}>
        <div className={Styles.takara_p_c__body__content}>
          <div className={Styles.takara_p_c__body__content__pageTitle}>
            <p className={Styles.takara_p_c__body__content__pageTitle__en}>comment</p>
            <h1 className={Styles.takara_p_c__body__content__pageTitle__title}>
              これまで煩雑だった<br className={Styles.takara_p_c__sbr} />決算開示業務における<br className={Styles.takara_p_c__sbr} />課題を両社のナレッジを<br className={Styles.takara_p_c__sbr} />融合し解決に導く
            </h1>
          </div>
          <p>
            この度、ユニフォース様の「クラウド決算開示管理サービス」と宝印刷の開示書類自動作成システム「WizLabo」のAPI連携が実現しました。これにより、上場企業の決算担当者の皆様に、より効率的でスムーズな業務環境を提供できるようになったことを大変嬉しく思います。
          </p>
          <p>
            近年、ESG開示の拡充により、決算業務に関与するステークホルダーが増加する傾向にあり、それに伴いタスク管理や進捗管理の負担が増大しています。この課題に対し、両システムのAPI連携は開示書類作成プロセスとタスク管理の統合を実現し、今までにない快適なユーザー体験をご提供できるものと確信しております。
          </p>
          <p>
            当社のICT事業は「ICTの力で決算関係者を本質的業務へと導く」というミッションを掲げており、この度の連携はそのミッションを具現化した象徴的な取り組みであります。今後も日本の上場企業の決算業務を支えるパートナーとして、ユニフォース社と共に革新的なソリューションを提供し続けてまいります。
          </p>
          <p className={Styles.takara_p_c__body__content__endtext}>
            宝印刷株式会社<br />
            執行役員 ICT営業部長　池主 丞
          </p>
        </div>
        <aside className={Styles.takara_p_c__body__aside}>
          <div className={Styles.takara_p_c__body__aside__takara}>
            <h2 className={Styles.takara_p_c__body__aside__takara__title}>
              <img
                src={withPrefix('/takara_p_c-logo_takara.svg')}
                alt="宝印刷"
                width={160}
              />
            </h2>
            <dl className={Styles.takara_p_c__body__aside__takara__content}>
              <dt>会社概要</dt>
              <dd className={Styles.takara_p_c__body__aside__takara__content__name}><strong>宝印刷株式会社</strong> 様</dd>
              <dt>事業内容</dt>
              <dd>
                ディスクロージャーからIRまで、ICTを活用した決算サポートを提供（開示書類作成ツール WizLabo、翻訳、コンサルティング、制作、印刷など）
              </dd>
              <dt>会社HP</dt>
              <dd><a href="https://www.takara-print.co.jp/" target="_blank" rel="noreferrer">https://www.takara-print.co.jp/</a></dd>
              <dt>主なサービス</dt>
              <dd className={Styles.takara_p_c__body__aside__takara__content__service}>
                <a href="https://www.wizlabo.jp/" target="_blank" rel="noreferrer"><img
                  src={withPrefix('/takara_p_c-logo_wizlabo.svg')}
                  alt="WizLabo"
                  width={218}
                /></a>
              </dd>
            </dl>
          </div>
        </aside>
      </div>
      
    </section>
    <Contact />
  </Layout>
)

export default Takara_p_cPage
